import { PATH_CUSTOMER, PATH_CUSTOMER_MOBILE, PATH_CUSTOMER_MOBILE_APP_REVIEW } from "./paths";
import React, { lazy } from 'react';
import AuthProtect from 'src/components/Auth/AuthProtect';

import AuthProtectNotifications from 'src/components/Auth/AuthProtectNotifications/AuthProtectNotifications';
import AuthProtectCompanyProfile from 'src/components/Auth/AuthProtectCompanyProfile/AuthProtectCompanyProfile';
import AuthProtectCompanyProfileView from 'src/components/Auth/AuthProtectCompanyProfile/AuthProtectCompanyProfileView';
import AuthProtectCompanyProfileEdit from 'src/components/Auth/AuthProtectCompanyProfile/AuthProtectCompanyProfileEdit';
import AuthProtectCompanyProfileAdd from 'src/components/Auth/AuthProtectCompanyProfile/AuthProtectCompanyProfileAdd';
import AuthProtectOffers from 'src/components/Auth/AuthProtectOffers/AuthProtectOffers';
import AuthProtectOffersView from 'src/components/Auth/AuthProtectOffers/AuthProtectOffersView';
import AuthProtectOffersAdd from 'src/components/Auth/AuthProtectOffers/AuthProtectOffersAdd';
import AuthProtectClosedOffers from 'src/components/Auth/AuthProtectClosedOffers/AuthProtectClosedOffers';
import AuthProtectPreOrder from 'src/components/Auth/AuthProtectPreOrder/AuthProtectPreOrder';
import AuthProtectPreOrderView from 'src/components/Auth/AuthProtectPreOrder/AuthProtectPreOrderView';
import AuthProtectPreOrderEdit from 'src/components/Auth/AuthProtectPreOrder/AuthProtectPreOrderEdit';
import AuthProtectCatalogue from 'src/components/Auth/AuthProtectCatalogue/AuthProtectCatalogue';
import AuthProtectCatalogueView from 'src/components/Auth/AuthProtectCatalogue/AuthProtectCatalogueView';
import AuthProtectCatalogueAdd from 'src/components/Auth/AuthProtectCatalogue/AuthProtectCatalogueAdd';
import AuthProtectRestockOrder from 'src/components/Auth/AuthProtectRestockOrder/AuthProtectRestockOrder';
import AuthProtectOrder from 'src/components/Auth/AuthProtectOrder/AuthProtectOrder';
import AuthProtectPayment from 'src/components/Auth/AuthProtectPayment/AuthProtectPayment';
import AuthProtectPaymentUpdate from 'src/components/Auth/AuthProtectPaymentUpdate/AuthProtectPaymentUpdate';
import AuthProtectOrderIssues from 'src/components/Auth/AuthProtectOrderIssues/AuthProtectOrderIssues';
import AuthProtectOverpayment from 'src/components/Auth/AuthProtectOverpayment/AuthProtectOverpayment';
import AuthProtectConsignment from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignment';
import AuthProtectConsignmentStockReturnable from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignmentStockReturnable';
import AuthProtectConsignmentReport from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignmentReport';
import AuthProtectConsignmentSkuOrder from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignmentSkuOrder';
import AuthProtectStockProducts from 'src/components/Auth/AuthProtectConsignment/AuthProtectStockProducts';
import AuthProtectReport from 'src/components/Auth/AuthProtectConsignment/AuthProtectConsignment';
import AuthProtectStaff from 'src/components/Auth/AuthProtectStaff/AuthProtectStaff';
import AuthProtectStaffEdit from 'src/components/Auth/AuthProtectStaff/AuthProtectStaffEdit';
import AuthProtectStaffAdd from 'src/components/Auth/AuthProtectStaff/AuthProtectStaffAdd';
import AuthProtectDistributor from 'src/components/Auth/AuthProtectDistributor/AuthProtectDistributor';
import AuthProtectDistributorAdd from 'src/components/Auth/AuthProtectDistributor/AuthProtectDistributorAdd';

import DashboardCustomerMobLayout from "src/layouts/DashboardCustomerMobLayout";

// ----------------------------------------------------------------------------

const AppCustomerMobileRoutes = {
  path: PATH_CUSTOMER_MOBILE,
  guard: AuthProtect,
  layout: DashboardCustomerMobLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------

    // DASHBOARD
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.dashboard,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/dashboard/index'))
    },

    // NOTIFICATIONS
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.notifications,
      guard: AuthProtectNotifications,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/notifications/Notifications'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.notificationDetail.view,
      guard: AuthProtectNotifications,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/notifications/detail/NotificationView'))
    },

    // OFFERS
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.offers,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/offers/Offers'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.offersDetail.view,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/offers/offer-detail/OfferView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.offersDetail.offerSuccess,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/offers/offer-detail/OfferSuccess'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.offersDetail.manageRating,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/offers/offer-detail/ManageRating'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.offersDetail.manageRecommendedCartonQty,
      guard: AuthProtectOffers,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/offers/offer-detail/ManageRecommendedCartonQty'))
    },

    // PRE ORDER
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.preOrder,
      guard: AuthProtectPreOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/pre-order/PreOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.preOrderDetail.view,
      guard: AuthProtectPreOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/pre-order/PreOrderView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.preOrderDetail.viewOrderDetail,
      guard: AuthProtectPreOrderEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/pre-order/ViewOrderDetail'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.preOrderDetail.staffPreOrderBreakdown,
      guard: AuthProtectPreOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/pre-order/StaffPreOrderBreakdown'))
    },

    // CLOSED OFFERS
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.closedOffers,
      guard: AuthProtectClosedOffers,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/closed-offers/ClosedOffers'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.closedOffersDetail.view,
      guard: AuthProtectClosedOffers,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/closed-offers/closed-offers-detail/ClosedOfferView'))
    },

    // ALL ORDER
    {
      exact: true, 
      path: PATH_CUSTOMER_MOBILE.general.orderAll,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/order-all/OrderAll'))
    },
    // {
    //   exact: true,
    //   path: PATH_CUSTOMER.general.orderAllDetail.view,
    //   component: lazy(() => import('src/views/CustomerDashboardGroup/invoice/detail/InvoiceView2'))
    // },

    // ORDER
    {
      exact: true, 
      path: PATH_CUSTOMER_MOBILE.general.order,
      guard: AuthProtectOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/invoice/Invoice'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.orderDetail.view,
      guard: AuthProtectOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/invoice/detail/InvoiceView2'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.orderDetail.skuList,
      guard: AuthProtectOrder,
      component: lazy(() => import('src/components/InboundOrderComponent/SKUList'))
    },

    // CONSIGNMENT
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignment,
      guard: AuthProtectConsignment,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/order-consignment/OrderConsignment'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignmentDetail.view,
      guard: AuthProtectConsignment,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/order-consignment/details/OrderConsignmentView'))
    },
    
    // PAYMENT
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.payment,
      guard: AuthProtectPayment,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/payment/Payment'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.paymentDetail.view,
      guard: AuthProtectPayment,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/payment/PaymentView'))
    },

    // PAYMENT UPDATE
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.paymentUpdate,
      guard: AuthProtectPaymentUpdate,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/payment-update/PaymentUpdate'))
    },

    // DISTRIBUTOR
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.distributor,
      guard: AuthProtectDistributor,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/distributor/Distributor'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.distributorView,
      guard: AuthProtectDistributor,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/distributor/DistributorView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.applyDistributor,
      guard: AuthProtectDistributorAdd,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/distributor/apply/ApplyDistributor'))
    },

    // REPORT
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.report,
      guard: AuthProtectReport,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/report/Report'))
    },

    // PROFILE
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.profile,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/profile/Profile'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.editProfile,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/profile/EditProfile'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.changeEmail,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/profile/ChangeEmail'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.changePassword,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/profile/ChangePassword'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.verificationCode,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/profile/VerificationCode'))
    },

    // RETAILER APPLICATION FORM
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.retailerApplicationForm,
      guard: AuthProtectCompanyProfile,
      component: lazy(() => import('src/views/CustomerMobileAppReviewGroup/retailer-application-form/RetailerApplicationForm'))
    },

    // EDIT RETAILER APPLICATION FORM FOR APPROVED STATUS
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.editRetailerApplicationForm.form001,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/edit-retailer-application-form/Form001'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.editRetailerApplicationForm.form002,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/edit-retailer-application-form/Form002'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.editRetailerApplicationForm.form003,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/edit-retailer-application-form/Form003'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.editRetailerApplicationForm.form004,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/edit-retailer-application-form/Form004'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.editRetailerApplicationForm.form005,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/edit-retailer-application-form/Form005'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.editRetailerApplicationForm.formAgreement,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/edit-retailer-application-form/FormAgreementTermsDistributor'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.editRetailerApplicationForm.formSummary,
      guard: AuthProtectCompanyProfileEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/edit-retailer-application-form/FormSummary'))
    },

    // CONSIGNMENT REPORT
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignmentReport,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-report/ConsignmentReport'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.addConsignmentReport.sale,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-report/new/AddConsignmentSale'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.addConsignmentReport.addProduct,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-report/new/ConsignmentAddProduct'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignmentReportDetail.view,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-report/details/ConsignmentReportView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.addConsignmentReport.auditStock,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-report/new/AddConsignmentAudit'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.addConsignmentReport.addProductForAudit,
      guard: AuthProtectConsignmentReport,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-report/new/audit-stock/ConsignmentAddProduct'))
    },

    
    // CONSIGNMENT STOCK RETURNABLE
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignmentStockReturnable,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-stock-returnable/ConsignmentStockReturnable'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignmentStockReturnableDetail.view,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-stock-returnable/details/ConsignmentStockReturnableView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.addConsignmentStockReturnable.new,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-stock-returnable/new/AddConsignmentStockReturnable'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.addConsignmentStockReturnable.addProduct,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-stock-returnable/new/ConsignmentAddProduct'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignmentStockReturnableDetail.edit,
      guard: AuthProtectConsignmentStockReturnable,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-stock-returnable/details/ConsignmentStockReturnableEdit'))
    },

    // CONSIGNMENT SKU ORDER
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignmentSkuOrder,
      guard: AuthProtectConsignmentSkuOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-sku-order/ConsignmentSkuOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.consignmentSkuOrderDetail.view,
      guard: AuthProtectConsignmentSkuOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/consignment-sku-order/detail/ConsignmentSkuOrderView'))
    },

    // CONSIGNMENT STOCK PRODUCTS
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.stockProducts,
      guard: AuthProtectStockProducts,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/stock-products/StockProducts'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.stockProductsDetail.view,
      guard: AuthProtectStockProducts,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/stock-products/StockProductsView'))
    },

    // STAFF
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.staff,
      guard: AuthProtectStaff,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/staff/Staff'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.addStaff,
      guard: AuthProtectStaffAdd,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/staff/new/AddStaff'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.staffDetail.view,
      guard: AuthProtectStaff,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/staff/details/StaffView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.staffDetail.edit,
      guard: AuthProtectStaffEdit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/staff/details/StaffEdit'))
    },

    // STAFF PRE ORDER
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.staffPreOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/staff-preorder/StaffPreOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.staffPreOrderDetail.view,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/staff-preorder/StaffPreOrderView'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.staffPreOrderDetail.generatePreOrder,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/staff-preorder/GeneratePreOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.staffPreOrderDetail.edit,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/staff-preorder/StaffPreOrderEdit'))
    },

    // ISSUED ORDER
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.addOrderIssue,
      guard: AuthProtectOrderIssues,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/order-issue/AddOrderIssue'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.orderIssues,
      guard: AuthProtectOrderIssues,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/order-issue/OrderIssues'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.orderIssuesDetail.view,
      guard: AuthProtectOrderIssues,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/order-issue/details/OrderIssueView'))
    },
    
    // OVERPAYMENT
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.overpayment,
      guard: AuthProtectOverpayment,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/credit-note/CreditNote'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.overpaymentDetail.view,
      guard: AuthProtectOverpayment,
      component: lazy(() => import('src/views/CustomerMobileDashboardGroup/credit-note/detail/CreditNoteView'))
    },

    // CATALOGUE
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.catalogueDetail.view,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/Catalogue'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.catalogueDetail.listProduct,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/list-product/ListProduct'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.catalogueDetail.productDetail,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/product/Product'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.cart.root,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/cart/Cart'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.cart.confirmation,
      guard: AuthProtectCatalogue,
      component: lazy(() => import('src/views/CustomerDashboardGroup/catalogue/cart/Confirmation'))
    },

    // RESTOCK ORDER
    {
      exact: true, 
      path: PATH_CUSTOMER_MOBILE.general.restockOrder,
      guard: AuthProtectRestockOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/restock-order/RestockOrder'))
    },
    {
      exact: true,
      path: PATH_CUSTOMER_MOBILE.general.restockOrderDetail.view,
      guard: AuthProtectRestockOrder,
      component: lazy(() => import('src/views/CustomerDashboardGroup/restock-order/RestockOrderView'))
    },
  ]
}

export default AppCustomerMobileRoutes